/**
 * 各业务方H5用户中心appid
 */
export const P_MALL_APPID = 'xp_ppstore'; // 商城H5

export const servicePhone = '4008193388'; // 客服电话

export const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'; // 充电CDN
